
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function TTFTotalTreeCostHeader() {
	return (
		<StickyNumericHeader
			style={{
				...offsetOneRow,
				width: '160px',
				minWidth: '160px',
				maxWidth: '160px'
			}}>
			TTF total tree cost
		</StickyNumericHeader>
	)
}

export function TTFTotalTreeCostFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.TTFTotalTreeCostValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, TTFTotalTreeCostValidated: e.value })
					}
				/>
				<NumericFilter
					value={filter?.TTFTotalTreeCost ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, TTFTotalTreeCost: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function TTFTotalTreeCostContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.TTFTotalTreeCostValidated && <ValidatedIcon />}
				</span>
				<span>{ppn.PlantingProject.TTFTotalTreeCost?.toLocaleString()}</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}